import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  dimension: Yup.object({
    width: Yup.number()
      .required('Width is required')
      .typeError('Width must be a integer')
      .integer('Width must be a integer'),
    height: Yup.number()
      .required('Height is required')
      .typeError('Height must be a integer')
      .integer('Height must be a integer'),
  }),
  position: Yup.object({
    top: Yup.number()
      .required('Top is required')
      .typeError('Top must be a integer')
      .integer('Top must be a integer'),
    left: Yup.number()
      .required('Left is required')
      .typeError('Left must be a integer')
      .integer('Left must be a integer'),
  }),
});

export default validationSchema;
